import { PageTitle } from './pageTitle'

export { PageTitle }
